import React from 'react'
import { Box, Avatar, Typography, Button, Menu, MenuItem, IconButton } from '@mui/material'
import { AccountCircle, ExitToApp } from '@mui/icons-material'
import { useAuth } from '../../context/AuthContext'
import { useNavigate } from 'react-router-dom'

const UserProfile = () => {
  const { currentUser, logout } = useAuth()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/login')
    } catch (error) {
      console.error('Failed to log out', error)
    }
    handleClose()
  }

  if (!currentUser) {
    return null
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        size='large'
        edge='end'
        color='primary'
        aria-label='account of current user'
        aria-controls='menu-appbar'
        aria-haspopup='true'
      >
        {currentUser.photoURL ? (
          <Avatar src={currentUser.photoURL} alt={currentUser.displayName || currentUser.email} sx={{ width: 32, height: 32 }} />
        ) : (
          <AccountCircle />
        )}
      </IconButton>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
            {currentUser.displayName || 'User'}
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
            {currentUser.email}
          </Typography>
        </Box>
        <MenuItem onClick={handleLogout}>
          <ExitToApp sx={{ mr: 1 }} />
          Logout
        </MenuItem>
      </Menu>
    </>
  )
}

export default UserProfile
